import { Component, OnInit, Input } from '@angular/core';
import { SetService, JwtService, PageService } from 'ngx-block-core';
import { HttpService, FormControlService } from 'ngx-block-core';
import { FormGroup } from '@angular/forms';
import { selectSize, selectMode, eventTypeInput } from "../../../data/data";
import { filter, distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd';

@Component({
  selector: 'app-sucu04-weiget0020001',
  templateUrl: './sucu04-weiget0020001.component.html',
})
export class Sucu04Weiget0020001Component implements OnInit {
  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() form: FormGroup;
  @Input() nzFormGroupData;
  @Input() nzLayout = 'horizontal'

  @Input() sets = {
    blockCode: "sucublock22",
    blockId: "",
    blockName: "下拉",
    layoutId: "",
    blockType: "formBlock",
    blockChildType: '',
    versionCode: 15,
    attributes: ['form', 'nzFormGroupData', 'nzLayout'],
    events: [
      {
        label: "重置",
        value: "reset",
        data: {}
      },
      {
        label: "刷新",
        value: "refresh",
        data: {}
      },
      {
        label: "可用不可用",
        value: "isable",
        data: {
          setParams: ["不可用值", '可用值', 'num']
        }
      },
      {
        label: "联动开关",
        value: "linkageControl",
        data: {
          setParams: ["关闭值", '启用值，可不填', '备用']
        }
      }
    ],
    styles: {
      nzText: "编号: ",
      nzSize: "default",
      nzPlaceHolder: "请输入内容",
      nzMinWidth: 100,
      nzLayout: {
        nzLayout1: 0,
        nzLayout2: 8,
        nzLayout3: 0,
        nzLayout4: 16,
        nzAlign: 'left',
        nzMarginBottom: 3,
        nzLineHeight: 1.4,
        nzFontSize: 12
      },
      nzAllowClear: true,
      nzShowSearch: true,
      nzMode: 'default',
      nzMaxMultipleCount: 100,
      nzRequired: false,
      nzHasFeedback: false,
      nzNoSee: false,
      nzReadOnly: false,
      nzExpandId: "",
      nzPopover: {
        nzUsed: false,
        nzContent: [],
        nzTrigger: 'click',
        nzButton: false,
        nzButtonType: 'jump',
        nzButtonText: '高级搜索'
      }
    },
    datas: {
      nzSaveEmpty: false,
      nzDynamicData: false,
      nzDynamicSearch: {
        nzDynamicSql: "",
        nzPaging: false,
        nzPageSize: 0,
        nzValueName: 'value',
        nzLabelName: 'label',
        nzSortMap: []
      },
      nzData: [],
      nzLinkage: {
        nzUsed: false,
        nzEvents: [
          // {
          //   blockid:blockid,
          //   type:"value"//value,datasource
          // }
        ],//blockid
      },
      nzLinkageData: {
        nzlinkageClosed: false,
        nzDynamicSql: ""
      },
      nzEvents: [

      ],
      nzEventsDatas: {
      },
      nzCloseValue: true,
      nzServiceParam: [],
      nzServiceParamDetail: { "sequ": 1 },
      nzJumpType: "self",
      nzJumpPageType: 0,
      nzJumpPage: "",
      nzJumpMode: "none",
      nzJumpModalTitle: "",
      nzJumpModalWidth: 520,
      nzSenceJson: [],
      nzValueSource: [],
    }
  };



  constructor(
    public setService: SetService,
    private http: HttpService,
    private jwtService: JwtService,
    private pageService: PageService,
    private formControlService: FormControlService,
    private activatedRoute: ActivatedRoute,
    private message: NzMessageService

  ) {
    console.log('00构造函数执行了---除了使用简单的值对局部变量进行初始化之外，什么都不应该做')
  }
  setnone = false
  ngOnInit() {
    console.log('02ngOnInit执行了--- 请求数据一般放在这个里面');
    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== '{}') {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.nzFormGroupData['nzSearchDataType'] = "string|array";
        if (this.sets.styles.nzMode == 'multiple')
          this.nzFormGroupData['nzSearchDataType'] = "simpleArray";
        if (this.sets.styles.nzNoSee == true)
          this.nzFormGroupData['nzSearchDataType'] = "noSee";
        this.nzFormGroupData['nzSearchType'] = "=";
        this.pzListening();
        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }


        // this.form.get(this.nzFormGroupData.nzKey).value
      }
      else {//静态
        if (typeof this.sets == "string")
          this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
      }
    }
    this.autoUpdate();
    if (this.sets.datas.nzDynamicData) {
      this.sets.datas.nzData = [];
      this.loadMore();
    }
    this.Listening()
    if (this.sets.styles.nzMode == 'multiple' && this.form.get(this.nzFormGroupData['nzKey']).value === '') {
      this.form.get(this.nzFormGroupData['nzKey']).patchValue(null);
    }
    //监听
    let control_name = this.nzFormGroupData.nzKey;
    this.form.get(control_name).valueChanges.pipe(
      //同valueChanges，不写也可
      distinctUntilChanged(),
      //防抖时间，单位毫秒
      debounceTime(200),
    ).subscribe((val) => {
      console.log("change-select", this.blockid, val, this.sets.datas.nzLinkage)
      if (typeof val === 'number' && !this.sets.datas.nzDynamicData) {
        console.log("change-select-number")
        this.form.get(control_name).patchValue(val + '');
        return;
      }

      this.pageService.pageBlockDatas[this.blockid] = {
        value: {
          label_value: this.valueLabel[val],
        }
      }
      console.log("label_value", this.pageService.pageBlockDatas[this.blockid])

      //事件
      this.sets.datas.nzEvents.forEach(element => {
        this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {
          switch (element) {
            case 'sendSimpleEvent':
              // this.endEvent.push(element);

              switch (itemEvents['name']) {
                case "search":
                  if (val !== null && val !== undefined) {
                    let data = {};
                    if (itemEvents['param1'] === '' || itemEvents['param1'] === null || itemEvents['param1'] === undefined) itemEvents['param1'] = '=';
                    data[itemEvents['param0']] = [
                      {
                        "name": itemEvents['param1'],
                        "type": "",
                        "instruction": "",
                        "value1": val,
                        "value2": ""
                      }
                    ]
                    this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], data)
                    console.log("jsonsss", JSON.stringify(this.sets.datas.nzEventsDatas[element]), data)
                  }

                  break;

                default:
                  let senddata = { value: val };
                  try {
                    senddata['param0'] = itemEvents['param0'];
                    senddata['param1'] = itemEvents['param1'];
                    senddata['param2'] = itemEvents['param2'];
                  } catch (error) {

                  }
                  console.log("send", this.blockid, itemEvents['blockid'], itemEvents['name'], senddata)
                  this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], senddata)
                  break;
              }

              break;

            default:
              break;
          }
        });

      });
      //联动
      if (this.sets.datas.nzLinkage.nzUsed) {
        this.sets.datas.nzLinkage.nzEvents.forEach(element => {
          console.log("nzLinkage", JSON.stringify(element), val);
          this.setService.sendEvent(element.blockid, "linkage" + element.type, { value: val })
        });
      }

    });
    console.log('nzReadOnly', this.sets.blockName, this.sets.styles.nzReadOnly);
    if (this.sets.styles.nzReadOnly) {
      console.log('disable', this.sets.blockName);
      this.form.get(this.nzFormGroupData.nzKey).disable();
    } else {
      console.log('enable', this.sets.blockName);
      this.form.get(this.nzFormGroupData.nzKey).enable();
    }


    this.nzLinkageClosed = this.sets.datas.nzLinkageData.nzlinkageClosed;

  }
  nzLinkageClosed = false;
  setData = []
  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormDataSource' },
              { name: 'nzLinkage', inputs: { otherSets: ['close'], nzBlockSets: this.sets } },


            ]
          }
        ]
      },
      {
        tabName: '功能',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
              },
              {
                name: 'select',
                inputs: { nzText: "模式 : ", nzKeys: ['styles', 'nzMode'], nzData: selectMode },
                outputs: {
                  ngModelChange: (event) => {
                    if (event === 'multiple') {
                      this.nzFormGroupData['nzSearchDataType'] = "simpleArray";
                    }
                    else {
                      this.nzFormGroupData['nzSearchDataType'] = "string|array";
                    }

                  }
                }
              },
              {
                name: 'switch',
                inputs: { nzText: "可搜索 : ", nzKeys: ['styles', 'nzShowSearch'], }
              },
              {
                name: 'switch',
                inputs: { nzText: "可清除 : ", nzKeys: ['styles', 'nzAllowClear'], }
              },
              {
                name: 'switch',
                inputs: { nzText: "保留空 : ", nzKeys: ['datas', 'nzSaveEmpty'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "只读 : ", nzKeys: ['styles', 'nzReadOnly'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.form.get(this.nzFormGroupData.nzKey).disable();
                    else
                      this.form.get(this.nzFormGroupData.nzKey).enable();
                  }
                }
              },
            ]
          },
          {
            type: 'datas',
            data: [
              { name: 'nzDynamicSearch' },
            ]
          }
        ]
      },
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "提示文字 : ", nzKeys: ['styles', 'nzPlaceHolder'] }
              },
              { name: 'nzLayout', inputs: { nzType: '选择框' } },
              {
                name: 'number',
                inputs: { nzText: "最小宽度 : ", nzKeys: ['styles', 'nzMinWidth'], nzStyle: [50, 1000, 10] }
              },
              {
                name: 'radio',
                inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize }
              },
              {
                name: 'switch',
                inputs: { nzText: "显示必选* : ", nzKeys: ['styles', 'nzRequired'], nzPopContent: ['仅影响样式'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "校验图标 : ", nzKeys: ['styles', 'nzHasFeedback'], nzPopContent: ['校验状态的图标'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "表单忽视 : ", nzKeys: ['styles', 'nzNoSee'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.nzFormGroupData['nzSearchDataType'] = "noSee";
                    else
                      this.nzFormGroupData['nzSearchDataType'] = "string|array";
                  }
                }
              },
              {
                name: 'nzPopover'
              },
            ]
          }
        ]
      },
      {
        tabName: '表单',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormSet' },
            ]
          }
        ]
      },
      {
        tabName: '高级功能',
        datas: [
          {
            type: 'datas',
            data: [
              { name: "nzEvents", inputs: { eventType: eventTypeInput } }
            ]
          },
        ]
      }
    ]
  }
  autoUpdate() {
    //vc:3
    //联动
    if (this.sets.versionCode < 3) {
      if (typeof this.sets.datas.nzLinkage == "undefined") {
        this.sets.datas['nzLinkage'] = {
          nzUsed: false,
          nzEvents: [

          ],
        };

      }
      this.sets.versionCode = 3;
      console.log("123");
    }


    //v3,升级自定义表单参数
    if (this.sets.versionCode < 4) {

      this.sets.blockCode = "sucublock22";

      this.sets.versionCode = 4;
      console.log("124");
    }
    if (this.sets.versionCode < 5) {

      this.sets.styles.nzNoSee = false;

      this.sets.versionCode = 5;
    }
    if (this.sets.versionCode < 6) {

      this.sets.datas.nzEvents = [];
      this.sets.datas.nzEventsDatas = {};

      this.sets.versionCode = 6;
    }
    //11





    if (this.sets.versionCode < 10) {

      this.sets.datas['nzSaveEmpty'] = false;

      this.sets.versionCode = 10;
    }
    if (this.sets.versionCode < 11) {

      this.sets.datas.nzDynamicSearch['nzSortMap'] = [];
      this.sets.versionCode = 11;
    }
    if (this.sets.versionCode < 11) {

      this.sets.styles['nzReadOnly'] = false;
      this.sets.versionCode = 11;
    }

    if (this.sets.versionCode < 13) {

      this.sets.styles['nzExpandId'] = "";
      this.sets.versionCode = 13;
    }
    if (this.sets.versionCode < 14) {

      this.sets['events'] = [
        {
          label: "重置",
          value: "reset",
          data: {}
        },
        {
          label: "刷新",
          value: "refresh",
          data: {}
        },
        {
          label: "可用不可用",
          value: "isable",
          data: {
            setParams: ["不可用值", '可用值', 'num']
          }
        },
        {
          label: "联动开关",
          value: "linkageControl",
          data: {
            setParams: ["关闭值", '启用值，可不填', '备用']
          }
        }
      ],

        this.sets.datas['nzLinkageData']['nzlinkageClosed'] = false;
      this.sets.versionCode = 14;
    }

    if (this.sets.versionCode < 15) {

      this.sets.styles['nzPopover'] = {
        nzUsed: false,
        nzContent: [],
        nzTrigger: 'click',
        nzButton: false,
        nzButtonType: 'jump',
        nzButtonText: '高级搜索'
      }
      this.sets.datas['nzJumpType'] = "self";
      this.sets.datas['nzJumpPageType'] = 0;
      this.sets.datas['nzJumpPage'] = "";
      this.sets.datas['nzJumpMode'] = "none";
      this.sets.datas['nzJumpModalTitle'] = "";
      this.sets.datas['nzJumpModalWidth'] = 520;
      this.sets.datas['nzSenceJson'] = [];
      this.sets.datas['nzCloseValue'] = true;
      this.sets.datas['nzServiceParam'] = [];
      this.sets.datas['nzServiceParamDetail'] = { "sequ": 1 }
      this.sets.datas['jumpLog'] = '';
      this.sets.datas['nzValueSource'] = [];
      this.sets.versionCode = 15;
    }

  }
  ngOnDestroy() {
    console.log('000ngngOnDestroy执行了', this.blockid);
    if (!this.static) this.setService.deleteEvent(this.blockid, 'pz')
    this.setService.deleteEvent(this.blockid);
  }
  linkValue = {
    linkage: "",
    linkage2: "",
    linkage3: ""
  }
  sql = "";
  nzOpen = false;
  Listening() {
    console.log("Listening", this.blockid)
    setTimeout(() => {
      this.setService.initEvent(this.blockid);
      this.setService.events[this.blockid].subscribe(
        data => {
          console.log("data", JSON.stringify(data))
          let array0 = [];
          let array1 = [];
          switch (data['type']) {
            case 'linkagevalue':
              break;
            case 'linkagedatasource':
              if (!this.nzLinkageClosed) {
                console.log("linkagedatasource", data['datas']['value'])

                this.linkValue.linkage = data['datas']['value'];

                //执行判断
                this.sql = this.sets.datas.nzLinkageData.nzDynamicSql;
                if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) this.sql = this.sql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
                if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) this.sql = this.sql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
                if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) this.sql = this.sql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);
                if (this.sql.indexOf("@linkage") == -1 && data['datas']['value'] !== null) {
                  if (this.sets.datas.nzDynamicData) {
                    this.sets.datas.nzData = [];
                    this.isLastPage = false;
                    this.nzNowPage = 0;
                    this.loadMore();
                  }
                } else {
                  this.sets.datas.nzData = [];
                  this.isLastPage = false;
                  this.nzNowPage = 0;
                  this.form.get(this.nzFormGroupData.nzKey).patchValue(null);
                }
              }


              break;
            case 'linkagedatasource2':
              if (!this.nzLinkageClosed) {
                console.log("linkagedatasource", data['datas']['value'])

                this.linkValue.linkage2 = data['datas']['value'];

                //执行判断
                this.sql = this.sets.datas.nzLinkageData.nzDynamicSql;
                if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) this.sql = this.sql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
                if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) this.sql = this.sql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
                if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) this.sql = this.sql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);
                if (this.sql.indexOf("@linkage") == -1 && data['datas']['value'] !== null) {
                  if (this.sets.datas.nzDynamicData) {
                    this.sets.datas.nzData = [];
                    this.isLastPage = false;
                    this.nzNowPage = 0;
                    this.loadMore();
                  }
                } else {
                  this.sets.datas.nzData = [];
                  this.isLastPage = false;
                  this.nzNowPage = 0;
                  this.form.get(this.nzFormGroupData.nzKey).patchValue(null);
                }
              }


              break;
            case 'linkagedatasource3':
              if (!this.nzLinkageClosed) {
                console.log("linkagedatasource", data['datas']['value'])

                this.linkValue.linkage3 = data['datas']['value'];

                //执行判断
                this.sql = this.sets.datas.nzLinkageData.nzDynamicSql;
                if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) this.sql = this.sql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
                if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) this.sql = this.sql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
                if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) this.sql = this.sql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);
                if (this.sql.indexOf("@linkage") == -1 && data['datas']['value'] !== null) {
                  if (this.sets.datas.nzDynamicData) {
                    this.sets.datas.nzData = [];
                    this.isLastPage = false;
                    this.nzNowPage = 0;
                    this.loadMore();
                  }
                } else {
                  this.sets.datas.nzData = [];
                  this.isLastPage = false;
                  this.nzNowPage = 0;
                  this.form.get(this.nzFormGroupData.nzKey).patchValue(null);
                }
              }


              break;
            case 'reset':
              this.form.get(this.nzFormGroupData.nzKey).patchValue('')
              this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
              this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
              if (!this.setnone) {
                this.setnone = true;
                this.sets.datas.nzData.push({
                  VALUE: "",
                  LABEL: "无"
                })
              }
              break;
            case 'refresh':
              this.sets.datas.nzData = [];
              this.isLastPage = false;
              this.nzNowPage = 0;
              this.loadMore();
              break;
            case 'isable':
              console.log("isable", data.datas)

              array0 = (data.datas.param0 + "").split(",");
              array1 = (data.datas.param1 + "").split(",");
              if (array0.indexOf(data.datas.value) >= 0) {
                //disable
                this.form.get(this.nzFormGroupData.nzKey).disable();
                if (data.datas.param2.indexOf('reset') >= 0) {
                  if (!this.setnone) {
                    this.setnone = true;
                    this.sets.datas.nzData.push({
                      VALUE: "",
                      LABEL: "无"
                    })
                  }

                  this.form.get(this.nzFormGroupData.nzKey).patchValue('')
                  this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
                  this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
                }


                // this.form.get(this.nzFormGroupData.nzKey).clearValidators()
                // this.form.get(this.nzFormGroupData.nzKey).clearAsyncValidators();
              } else if (array1.indexOf(data.datas.value) >= 0 || data.datas.param1 == "") {
                // enable
                this.form.get(this.nzFormGroupData.nzKey).enable();
                // this.formControlService.setValidators(this.form, this.nzFormGroupData.nzKey, this.nzFormGroupData);
              }
              if (data.datas.param2.indexOf('linkageChange') >= 0) {
                this.nzLinkageClosed = !this.nzLinkageClosed;
              }
              break;
            case 'linkageControl':
              array0 = (data.datas.param0 + "").split(",");
              array1 = (data.datas.param1 + "").split(",");
              if (array0.indexOf(data.datas.value) >= 0) {
                //disable
                this.sets.datas.nzLinkage.nzUsed = false;

              } else if (array1.indexOf(data.datas.value) >= 0 || data.datas.param1 == "") {
                // enable
                this.sets.datas.nzLinkage.nzUsed = true;
                // this.form.get(this.nzFormGroupData.nzKey).enable();
              }
              break;
            case 'linkagesetValue':
              this.form.get(this.nzFormGroupData.nzKey).patchValue(data.datas.value)
              break;
            case 'setValues':
              this.sets.datas.nzValueSource.forEach(element => {
                if (data.datas[element.key] !== undefined) {
                  console.log('setValues', element, data.datas[element.key])
                  this.setService.sendEvent(element.blockid, "linkagesetValue", { value: data.datas[element.key] })
                }
              });
              break;
            case 'focus':
              // console.log('focus:',this.blockid,this.form.get(this.nzFormGroupData.nzKey).disabled,this.form.get(this.nzFormGroupData.nzKey).enabled);
              if (this.form.get(this.nzFormGroupData.nzKey).enabled) {
                this.nzOpen = true;
              }

              break;
            default:
              break;
          }


        }
      )
    }, !this.static ? 100 : 0);


  }
  pzListening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid, 'pz');
      this.setService.pzEvents[this.blockid].subscribe(

        data => {
          console.log("pzlisten", JSON.stringify(data))
          switch (data['type']) {
            case 'nzDynamicDatatrue':

              break;
            case 'nzDynamicDatafalse':
              this.sets.datas.nzData = [];
              this.sets.datas.nzDynamicSearch.nzPaging = false;
              break;
            case 'nzPagingfalse':
              this.sets.datas.nzDynamicSearch.nzPageSize = 0;
              break;
            case 'refresh':
              this.sets.datas.nzData = [];
              this.isLastPage = false;
              this.nzNowPage = 0;
              this.loadMore();
              break;
            case 'changeFormValid':
              this.formControlService.setValidators(this.form, this.nzFormGroupData.nzKey, this.nzFormGroupData);
              break;
            case 'savadefault':
              this.nzFormGroupData['nzValue']['nzValue'] = this.form.get(this.nzFormGroupData['nzKey']).value;
              console.log("nzFormGroupData", JSON.stringify(this.nzFormGroupData))
              break;

            default:
              break;
          }
        }
      )
    }, 100);

  }


  valueLabel = {};
  isLoading = false;
  isLastPage = false;
  nzNowPage = 0;
  searchvalue = ""
  isFirstInitSelected = true;
  initSelected() {
    let sql = this.sets.datas.nzDynamicSearch.nzDynamicSql;
    console.log("initSelectedsql:" + sql);
    if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) sql = sql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
    if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) sql = sql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
    if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) sql = sql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);
    console.log("数据表sql2:" + this.sets.datas.nzDynamicSearch.nzDynamicSql);
    console.log("数据表sq2:" + sql);
    if (sql.indexOf("@linkage") == -1) {
      let body = {
        "dynamicSql": this.pageService.replaceParam(this.jwtService.replaceUser(sql), this.layoutid),
        "pageSize": this.sets.datas.nzDynamicSearch.nzPaging ? this.sets.datas.nzDynamicSearch.nzPageSize : "0",
        "nowPage": this.nzNowPage,
        "paramMap": [

        ],
        "tableSort": this.sets.datas.nzDynamicSearch.nzSortMap,
        "searchMap": {}
      }

      if (this.sets.datas.nzDynamicSearch.nzPaging) {
        const value = this.form.get(this.nzFormGroupData.nzKey).value;
        if (this.isFirstInitSelected && value != "" && value != null) {//编辑时，如果列表里没有自己，则选值无效，所以要拿自己当条件搜一次
          this.searchvalue = value;
        }
        this.isFirstInitSelected = false;
        if (this.searchvalue != "") {
          body['searchMap'][this.sets.datas.nzDynamicSearch.nzValueName] = [
            {
              "name": "like",
              "value1": this.searchvalue
            }
          ]
        }

      }
      console.log("选项body:" + JSON.stringify(body));
      this.http.postHttp("/system/dynamicSql", body).subscribe(
        (data: any) => {
          if (data.data.list.length > 10000) {
            this.message.error('数据太多，请分页');
            return;
          }
          console.log("选项value", this.nzNowPage, body.dynamicSql, +'\n' + this.searchvalue, this.sets.datas.nzSaveEmpty, "选项:" + JSON.stringify(data));
          this.isLoading = false;
          if (data.data.pages >= this.nzNowPage || !this.sets.datas.nzDynamicSearch.nzPaging) {
            if (data.data.isLastPage === true) this.isLastPage = true;
            const value = this.form.get(this.nzFormGroupData.nzKey).value;
            // console.log("value", this.searchvalue, value, this.sets.datas.nzSaveEmpty, "选项:" + JSON.stringify(data));
            if (this.nzNowPage > 1) {
              this.sets.datas.nzData = [...this.sets.datas.nzData, ...data.data.list];
            } else {
              this.setnone = false;
              this.sets.datas.nzData = [...data.data.list];
            }
            //多选的特殊处理
            if (this.sets.styles.nzMode === 'multiple') {
              return;
            }
            // 判断选项是否有效
            let flag = false;
            this.sets.datas.nzData.forEach(element => {
              if (element.VALUE == value) flag = true;
              this.valueLabel[element.VALUE] = element.LABEL;
            });
            console.log("选项value", this.sets.datas.nzData, this.sets.datas.nzData.length);

            if (this.sets.datas.nzData.length > 0) {
              if (value == "" || value == null) {
                if (!this.sets.datas.nzSaveEmpty)
                  this.form.get(this.nzFormGroupData.nzKey).patchValue(this.sets.datas.nzData[0].VALUE)
              }
              else {

                if (!flag) this.form.get(this.nzFormGroupData.nzKey).patchValue(this.sets.datas.nzData[0].VALUE);
                else
                  this.pageService.pageBlockDatas[this.blockid] = {
                    value: {
                      label_value: this.valueLabel[value],
                    }
                  }
              }
            } else {
              this.addNone();
            }
          } else {
            if (data.data.pages == 0) {
              this.addNone();
            }
          }




        }, (err: any) => {
          console.error('选项err', body, err)
        });
    }


    else {
      this.addNone();
      this.isLoading = false;
    }

  }
  addNone() {
    console.log("选项value-加无", this.sets.datas.nzData);

    // this.setnone = true;
    // this.sets.datas.nzData.push({
    //   VALUE: "",
    //   LABEL: "无"
    // })
    this.form.get(this.nzFormGroupData.nzKey).patchValue(null);
    this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
    this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
    this.pageService.pageBlockDatas[this.blockid] = {
      value: {
        label_value: "",
      }
    }
  }
  scrollLoadMore() {
    console.log("scrollLoadMore", this.sets['datas']['nzDynamicSearch']['nzPaging'])
    if (this.sets['datas']['nzDynamicSearch']['nzPaging'])
      this.loadMore();
  }
  loadMore() {
    console.log("loadMore", this.sets.blockName)
    if (!this.isLastPage) {
      this.isLoading = true;
      this.nzNowPage = this.nzNowPage + 1;
      this.initSelected();
    }
  }
  /** 是否做过搜索 */
  isDoSearch = false
  search(event) {
    console.log("选项，search", event)
    if (event != "" && event != null) {
      this.searchvalue = event;
      this.isDoSearch = true;
      this.isLastPage = false;
      this.nzNowPage = 0;
      this.sets.datas.nzData = [];
      this.loadMore();
    }

  }

  onClick() {
    if (this.sets.styles['nzPopover']['nzUsed'] && this.sets.styles['nzPopover']['nzButton']) {
      console.log('onClick', this.sets.styles['nzPopover']['nzUsed'], this.sets.styles['nzPopover']['nzButton'])
    } else {
      this.popClick();
    }
  }
  popVisible = false;
  popClick() {
    console.log('nzJumpType', this.sets.datas.nzJumpType)
    if (this.sets.datas.nzJumpType === 'pop') {
      if (!this.static) {//配置环境
        console.log('!static')

      } else {
        const dateSets = {
          "type": this.sets.datas.nzJumpType,
          "mode": this.sets.datas.nzJumpMode,
          "nzSenceJson": this.sets.datas.nzSenceJson,
          "pageRoute": this.sets.datas.nzJumpPage,
          "modalTitle": this.sets.datas.nzJumpModalTitle,
          "modalWidth": this.sets.datas.nzJumpModalWidth,
          'acceptBlockId': this.blockid
        }
        // if (this.sets.datas.nzCloseValue) {
        //   dateSets['acceptBlockId'] = this.blockid;
        // }
        let queryParams = {};
        this.sets.datas['nzServiceParam'].forEach(param => {
          queryParams[this.sets.datas['nzServiceParamDetail'][param]['urlName']] = this.pageService.getServiceParam(this.sets.datas['nzServiceParamDetail'][param], this.activatedRoute);
        });
        this.popVisible = false;
        this.pageService.goRouter(dateSets, queryParams, '', this.sets.datas['jumpLog']);
      }

    }

  }



}
